import { Text, TextType } from 'ui-components/components/text';

import style from './extended-products-tab.module.less';
import { messages } from './messages';
import { ProductHandlingCard } from './product-handling-card/product-handling-card';
import { ProductSynchronizationCard } from './product-synchronization-card/product-synchronization-card';
import { MarketplaceIds } from '../../../../../enums/marketplace-ids';

export type StoreSetting = {
  name: string;
  value: string;
};

type MatchedOrderSource = {
  name: string;
  marketplaceId: number;
};

type ProductsTabProps = {
  products: {
    createNewProducts: boolean;
    matchProductByName: boolean;
    createAdjustmentProducts: boolean;
  };
  storeGuid: string;
  storeSettings: StoreSetting[];
  matchedOrderSource?: MatchedOrderSource;
};

export const ExtendedProductsTab = ({ products, storeGuid, storeSettings = [], matchedOrderSource }: ProductsTabProps) => {
  const isShopifyStore = matchedOrderSource?.marketplaceId === MarketplaceIds.Shopify;

  return (
    <div className={style['products-tab']}>
      <div className={style['tab-header']}>
        <Text textType={TextType.Paragraph} value={messages.productTabDescription} />
      </div>
      {isShopifyStore ? <ProductSynchronizationCard storeGuid={storeGuid} storeSettings={storeSettings} /> : null}
      <ProductHandlingCard products={products} />
    </div>
  );
};
